import React, { ReactElement, useEffect, useState } from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography, FormControl, Button, CircularProgress } from '@material-ui/core';
import useUser from 'hooks/useUser';
import PurchaseOrderList from 'components/organisms/PurcharseOrderList';
import usePurchaseOrders from 'hooks/usePurchaseOrders';
import useUserRole from 'hooks/useUserRole';

// Datepicker
import { formatISO, addDays } from 'date-fns';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { DatePurchaseOrders, IPurchaseOrderList } from 'interfaces/purchaseOrders.interface';

export default function PurchaseOrders(): ReactElement {
  const [purchaseOrders, setPurchaseOrders] = useState<IPurchaseOrderList[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [datePurchaseOrders, setDatePurchaseOrders] = useState<DatePurchaseOrders>({
    initDate: formatISO(addDays(new Date(), -30)),
    finDate: formatISO(new Date())
  });
  const userRole = useUserRole();
  const { user } = useUser();
  const { getAllPurchaseOrders, getAllPurchaseOrdersAdmin } = usePurchaseOrders();

  const handleGetOrders = () => {
    setIsLoading(true);
    if (user && userRole === 'administrator') {
      getAllPurchaseOrdersAdmin(datePurchaseOrders.initDate, datePurchaseOrders.finDate)
        .then((purchaseOrders: IPurchaseOrderList[]) => {
          setPurchaseOrders(purchaseOrders ? purchaseOrders : []);
        })
        .catch(() => {
          // TODO redireccionar en 403
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      getAllPurchaseOrders()
        .then((purchaseOrders: IPurchaseOrderList[]) => {
          setPurchaseOrders(purchaseOrders ? purchaseOrders : []);
        })
        .catch(() => {
          // TODO redireccionar en 403
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    handleGetOrders();
  }, []);

  return (
    <AdminTemplate>
      <React.Fragment>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography variant="h5" component="h1" align="center">
              Listado de Ordenes de Compra
            </Typography>
          </Grid>
          {user && userRole === 'administrator' ? (
            <Grid item xs={12} sm={12} md={10}>
              <Grid container direction="row" justify="flex-end" alignItems="flex-end">
                <FormControl variant="outlined">
                  <KeyboardDatePicker
                    autoFocus
                    name="initDate"
                    value={datePurchaseOrders.initDate}
                    label="Fecha de Inicio"
                    format="yyyy-MM-dd"
                    style={{ width: '90%', marginTop: 10 }}
                    onChange={(date) => {
                      if (date != null) setDatePurchaseOrders({ ...datePurchaseOrders, initDate: date.toISOString() });
                    }}
                    inputVariant="outlined"
                    maxDate={new Date()}
                  />
                </FormControl>
                <FormControl variant="outlined">
                  <KeyboardDatePicker
                    name="finDate"
                    value={datePurchaseOrders.finDate}
                    label="Fecha Final"
                    style={{ width: '90%', marginTop: 10 }}
                    format="yyyy-MM-dd"
                    onChange={(date) => {
                      if (date != null) setDatePurchaseOrders({ ...datePurchaseOrders, finDate: date.toISOString() });
                    }}
                    inputVariant="outlined"
                    maxDate={new Date()}
                  />
                </FormControl>
                <Button
                  disabled={isLoading}
                  variant="contained"
                  color="primary"
                  style={{ height: 55, marginRight: 20 }}
                  onClick={() => handleGetOrders()}
                >
                  {isLoading ? <CircularProgress size={24} /> : ''} Buscar
                </Button>
              </Grid>
            </Grid>
          ) : null}

          <Grid item xs={12} sm={12} md={10}>
            <PurchaseOrderList isLoading={isLoading} purchaseOrders={purchaseOrders} />
          </Grid>
        </Grid>
      </React.Fragment>
    </AdminTemplate>
  );
}
